module.exports = __webpack_public_path__ + "static/media/build-the-future.5f33845c.png";